import { useSheetContext } from "@/context/sheet";
import { useCreateServiceProvider } from "@/hooks/service-providers/create.hooks";
import { CreateServiceProvider } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { Form } from "./-form";

export const Route = createFileRoute(
  "/(service-providers)/service-providers/$id/_sheet/new"
)({
  component: RouteComponent,
  validateSearch: z.object({
    domain: z.enum(["service", "provider"]),
  }),
});

function RouteComponent() {
  const { domain } = Route.useSearch();
  const { id } = Route.useParams();
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateServiceProvider(domain, id, {
    onSuccess: () => {
      close(() => {
        navigate({
          to: "/service-providers/$id",
          params: { id },
          search: { domain },
        });
      });
    },
  });

  const create = async (serviceProvider: CreateServiceProvider) => {
    await mutateAsync(serviceProvider);
  };

  return <Form onUpsert={create} domain={domain} domainId={id} />;
}
